import css from '@styled-system/css';

export const MOBILE_WIDTH = 640;
export const MOBILE_PX_RATIO = 100 / MOBILE_WIDTH;

export const scale = (px: number) => `${px * MOBILE_PX_RATIO}vw`;
const SCALED_PX = Object.freeze([...Array(MOBILE_WIDTH + 1)].map((_, i) => scale(i)));
const scaledTheme = {
  space: SCALED_PX,
  sizes: SCALED_PX,
  fontSizes: SCALED_PX,
  borderWidths: SCALED_PX,
  raddi: SCALED_PX,
};

export const scaledCss: typeof css = args => (props = {}) => {
  return css(args)({
    ...props,
    theme: {
      // @ts-ignore
      ...props.theme,
      ...scaledTheme,
    },
  });
};
